var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 78,
    viewBox: "0 0 83 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12.7498 63.0699C7.64077 56.9812 8.43711 47.8789 14.5258 42.7699L28.7684 30.819L23.0917 24.0538L8.84911 36.0047C-0.978261 44.2508 -2.26158 58.9192 5.98457 68.7466C14.2307 78.5739 28.8991 79.8573 38.7265 71.6111L52.969 59.6602L47.2923 52.895L33.0498 64.8459C26.9611 69.9549 17.8588 69.1586 12.7498 63.0699ZM30.3362 54.3808L58.8213 30.4789L52.8458 23.3577L24.3607 47.2595L30.3362 54.3808ZM44.4555 6.12735L30.213 18.0783L35.8897 24.8435L50.1322 12.8926C56.2209 7.78354 65.3232 8.57989 70.4322 14.6686C75.5412 20.7573 74.7449 29.8595 68.6562 34.9686L54.4136 46.9195L60.0903 53.6847L74.3329 41.7338C84.1603 33.4876 85.4436 18.8193 77.1974 8.99189C68.9513 -0.835485 54.2829 -2.1188 44.4555 6.12735Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory14);
export default __webpack_public_path__ + "static/media/category-14.b9a7b175ddc6446ebb8b2b703f2745e1.svg";
export { ForwardRef as ReactComponent };